import { Service, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { urlBuilder } from '../../api-helpers';
import { FeedbackPayload } from './types';

@Service()
export class FeedbackService {
  private http = inject(HttpClient);

  submit(payload: FeedbackPayload) {
    return this.http.post(urlBuilder('/feedback'), payload);
  }
}
